<template>
  <div class="home bg-color">
    <div class="middle min-container">
      <div class="container">
        <div class="report_con">
          <!--           <div class="left center">
            <div
              class="left_item bg-color highlight"
              @click="toJump('legalPrivacy')"
            >Privacy Policy</div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalTerms')"
            >Terms of Service</div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalUnsolicited')"
            >Unsolicited Ideas</div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalCommunity')"
            >Community Rules</div>
          </div> -->
          <div class="right home-p-color">
            <div>
              <h2 class="title home-color">
                TERMS OF USE - PPWC REGISTRATION SYSTEM
              </h2>
              <p>These terms of use (“Agreement”) should be read by you in its entirety, together with the Privacy Policy and the Official Rules for PPPoker World Championship Brazil 2020 Main Event Seat Satellite (the “Official Rules”), prior to your use of PPWC 2020 Registration System (the “System”) in order to register for PPPoker World Championship Brazil 2020 Main Event (the “Event”) . As used in this Agreement, except as may otherwise be provided herein, all capitalized terms which are defined in this Agreement shall have the same meaning herein as therein, all of such terms and their definitions being incorporated herein by reference.</p>
              <p>The Event is sponsored by AceKing Tech Limited (the “Sponsor”). The Sponsor in its sole and absolute discretion may engage certain third parties to administer various aspects of the Event on its behalf. In this Agreement, the term “Sponsor” includes those third parties.</p>
              <p>Please note that this Agreement: (a) is a legally binding agreement between you and the Sponsor; (b) constitutes our entire understanding with respect to your participation in the Event and/or use of the System, where applicable.</p>
              <p>You hereby represent that you have not relied on any representation or assurances, whether written or oral made by the Sponsor other than those expressly set forth in this Agreement.  </p>
              <p>You should note that the Sponsor shall have the right, in its sole discretion, to take all such action as it deems reasonable in order to enforce the terms and conditions of this Agreement at all times.</p>
              <h2>TOURNAMENT REGISTRATION – PPWC REGISTRATION SYSTEM </h2>
              <p>1.  Registration via the System requires the input of i) your personal information, including but not limited to your name, age and passport/ID/resident card information; and ii) the 12-digit Ticket Number and the 16-digit Serial Number (collectively, the “Verification Code”) printed on the e-ticket. You warrant and undertake to ensure that your personal information relating to the registration of your e-ticket shall be current and up-to-date at all times. </p>
              <p>2.  E-tickets, whether registered or not, are non-refundable under any circumstances. </p>
              <p>3.  Following a registration, you will receive an email from the Sponsor, confirming your registration and personal information. </p>
              <p>4.  Subject to the Sponsor’s sole discretion, after the registration, you may make minor changes to your personal information.  </p>
              <p>5.  You are required to obtain all travel documents including but not limited to a valid visa by yourself with no assistance from the Sponsor. Failure to do so itself shall not constitute a valid reason for a refund. Once the Event commences, you will not be permitted to cancel your reservation for nor will you be refunded should you fail to participate in the Event.  </p>
              <p>6.  The e-ticket is issued by the Sponsor and shall remain its property at all time. The Sponsor may, at any time, restrict, suspend or terminate its use or alter or amend the conditions of all the same. </p>
              <p>7.  The Sponsor reserves the right to decline to issue, withdraw or cancel the e-ticket if at any time it reasonably believes that you:</p>
              <p>(a) have abused or attempted to abuse the use of the e-ticket or PPPoker account system (collectively, the “PPPoker Assets”); </p>
              <p>(b) have breached or attempted to breach any term or condition relating to the use of any PPPoker Asset or participation in the Event that it becomes aware of and that it informs you of by way of written notice;</p>
              <p>(c) have engaged in any abusive, offensive, disreputable, or violent behaviour, act or omission, or supplied false or misleading information either in relation to your acceptance, receipt or use of any PPPoker Assets, attendance at the Event or participation in the Event.</p>
              <p>The Sponsor reserves the right to seek damages and other remedies from any such   person to the fullest extent permitted by law.</p>
              <h2> LIMITATION OF LIABILITY</h2>
              <p>8.  The e-ticket (together with all information contained therein) is not transferable, cannot be copied and may only be used by you for the purposes expressly permitted by us hereunder.</p>
              <p>9.  The Sponsor disclaims any and all warranties, expressed or implied, in connection with   your access to and use of the PPPoker Assets which are provided to you "AS IS". To the extent permitted by applicable law, no warranty or representation whatsoever is given regarding the quality, or fitness for purpose or freedom from defects of the PPPoker Assets or that any information hereunder is complete and accurate. The Sponsor reserves the right to suspend, discontinue, modify, remove or add to any element of the PPPoker Assets in its absolute discretion with immediate effect and without an obligation to provide you with notice;  to suspend, discontinue, modify the date of the Event in its absolute discretion with immediate effect and without an obligation to provide you with notice. </p>
              <p>10. The use and safekeeping of the Verification Code remains your responsibility once it has been sent to you. The first Entrant to validly enter a Verification Code and fill in the required personal information in the System in order to register a e-ticket will be the only Entrant who registers for the Event using that particular code. The Sponsor is not required to establish in any case whether the e-ticket is in fact registered by the Entrant who first received such Verification Code. </p>
              <h2>MISCELLANEOUS</h2>
              <p>11. Force Majeure/Production Errors Or Omissions: Subject to any governmental approval which may be required, the Sponsor reserves the right, without prior notice and at any time, to terminate the Event, in whole or in part, or to modify, suspend or extend the Event, if it determines, in its sole discretion, that the Event in any way and for any reason is impaired or corrupted or that fraud or technical problems, failures or malfunctions have destroyed or severely undermined the proper play, integrity and/or feasibility of the Event. In the event that, in the Sponsor’s sole opinion, the Sponsor is impeded or prevented from continuing with the Event as planned or intended by any event beyond its control, including, but not limited to fire, flood, natural or manmade epidemic or crisis, earthquake, explosion, labour dispute or strike, act of God or public enemy, satellite or equipment failure, riot or civil disturbance, terrorist threat or activity, war (declared or undeclared), any federal, provincial, territorial or local government law, order or regulation, public health crisis, the order of any court or jurisdiction, or by any other cause not reasonably within the Sponsor’s control, then subject to any governmental approval that may be required, the Sponsor shall have the right to modify, suspend, extend or terminate the Event. </p>
              <p>12. Invalidity: The invalidity or unenforceability of any provision of this Agreement shall not affect the validity or enforceability of any other provision. In the event that any provision is determined to be invalid or otherwise unenforceable or illegal, this Agreement shall otherwise remain in effect and shall be construed in accordance with its terms as if the invalid or illegal provision were not contained herein. Headings and captions are used in this Agreement solely for ease of reference, and shall not be deemed or considered to affect in any manner the meaning or intent of this Agreement or any provision hereof. This Agreement cannot be modified or amended in any way except in writing by a duly authorized representative of the Sponsor. Subject to the provisions of this Agreement, employees of the Sponsor are not authorized to modify, amend or waive these Agreement.</p>
              <p>13. Governing Law: Subject to any provision expressly to the contrary in this Agreement, all issues and questions concerning the construction, validity, interpretation and enforceability of this Agreement or the rights and obligations as between one or more Entrants and the Sponsor in connection with the Event shall be governed by and construed and interpreted in accordance with the laws of England and Wales. </p>
              <p>Entrants and the Sponsor hereby irrevocably submit to the non-exclusive jurisdiction of the courts of England for the purpose of hearing and determining any dispute arising out of or in connection with this Agreement or their formation or validity. </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      index: 1
    }
  },
  created () {
    // this.index = parseInt(this.$route.params.item)
    this.$store.commit('changeTab', '/home')
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    toJump (name) {
      this.$router.push({ name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  // padding: 65px 0px 65px 0px;
  margin-top: -60px;
  min-width: 1200px;
  .middle {
    position: relative;
    // background-color: #2a2a2a;
    padding: 0px;
    .report_con {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      // min-height: 1000px;
      .left {
        position: relative;
        display: inline-block;
        width: 224px;
        .left_item {
          width: 220px;
          height: 55px;
          margin-bottom: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .p1 {
            font-size: 14px;
            text-align: left;
          }
          .p2 {
            font-size: 12px;
            color: #7b7b7b;
            text-align: right;
          }
        }
        .highlight {
          background-color: #58b26d;
        }
      }
      .right {
        position: relative;
        width: 868px;
        display: inline-block;
        padding: 52px 44px;
        .title {
          font-size: 34px;
        }
        h2 {
          margin: 30px 0px 20px 0px;
          font-size: 28px;
        }
        h2:nth-child(1) {
          margin-top: 0px;
        }
        p {
          font-size: 14px;
          margin-bottom: 10px;
          line-height: 24px;
          a {
            color: #1f9d56;
          }
        }
      }
    }
  }
}
</style>
